export class UserLangUtils {
  private static readonly DEFAULT_LANGUAGE = 'en-GB';
  private static readonly DEFAULT_SEPARATORS = { decimal: '.', thousand: ',' };

  public static getUserLanguages(): string[] {
    return [this.getUserRegionLocale()];
  }

  public static getUserRegionLocale(): string {
    if (typeof Intl !== 'undefined' && Intl.DateTimeFormat != null) {
      return Intl.DateTimeFormat()?.resolvedOptions().locale;
    }
    // Fallback to navigator.language if Intl API is unavailable
    return navigator.language || this.DEFAULT_LANGUAGE;
  }

  public static getLocaleSeparators(locale?: string): { decimal: string, thousand: string } {
    const format = new Intl.NumberFormat(locale ?? this.getUserRegionLocale());

    const parts = format.formatToParts(1234567.89);
    const separators = parts.reduce((acc, part) => {
      if (part.type === 'decimal') acc.decimal = part.value;
      if (part.type === 'group') acc.thousand = part.value;
      return acc;
    }, { ...this.DEFAULT_SEPARATORS });

    const isInvalidThousand = separators.thousand === ' ' || separators.thousand === '\u00A0'; //this is added due to the way we format values in myTC
    if (isInvalidThousand) {
      return { ...this.DEFAULT_SEPARATORS };
    }

    return separators;
  }
}
